import { AuthenticationGuard } from 'components/providers/AuthGuard';
import React from 'react'
import { Outlet } from 'react-router-dom';

const FormBuilderWrapperLayout = () => {
  return (
    <div>
        <Outlet/>
    </div>
  )
}

const Protected = () => {
  return <AuthenticationGuard component={FormBuilderWrapperLayout} />;
};

export default Protected;